<template>
    <div :class="{'display-inline-flex': fluid}" :style="styles">
        <div>
            <v-popper-select
                label="Schedule type"
                :options="periodTypesList"
                :validate="validate.periodType"
                :value="periodType"
                @input="updatePeriodType"/>
        </div>
        <component
            :is="getComponent({periodType})"
            :fluid="fluid"
            :validate="validate.period"
            :weekType="weekType"
            :day="day"
            :time="time"
            v-on:update="updateData"/>
    </div>
</template>

<script>
    import _ from '@/common/helpers';
    import {vPopperSelect} from '@/components/form';
    import {periodTypes} from '@/components/inline-time-period/period-types';
    import {weekTypes} from '@/components/inline-time-period/week-types';

    import DayOfMonth from '@/components/inline-time-period/components/day-of-month';
    import DayOfWeek from '@/components/inline-time-period/components/day-of-week';
    import Immediately from '@/components/inline-time-period/components/immediately';

    const periodTypesCached = Object.values(periodTypes);
    const weekTypesCached = Object.values(weekTypes);

    export default {
        name: 'inline-time-period',
        components: {
            vPopperSelect,
        },
        props: {
            availablePeriodTypes: {
                type: Array,
                required: true,
                validator: value => value.every(val => periodTypesCached.includes(val)),
            },
            customPeriodTypeLabels: {
                type: Object,
                required: false,
                default: () => ({}),
            },
            periodType: {
                type: String,
                validator: value => periodTypesCached.includes(value),
            },
            weekType: {
                type: String,
                validator: value => weekTypesCached.includes(value),
            },
            day: {},
            time: {},
            fluid: {
                type: Boolean,
                default: false,
            },
            validate: {
                type: Object,
                required: true,
            },
        },
        computed: {
            styles() {
                return this.fluid ? {width: '100%'} : {};
            },
            periodTypesList() {
                const customLabels = this.customPeriodTypeLabels;
                return periodTypesCached
                    .filter(type => this.availablePeriodTypes.includes(type))
                    .map(type => ({
                        label: customLabels[type] || _.unKebabCase(type),
                        value: type,
                    }));
            },
        },
        methods: {
            getComponent({periodType}) {
                switch (periodType) {
                    case periodTypes.dayOfMonth:
                        return DayOfMonth;
                    case periodTypes.dayOfWeek:
                        return DayOfWeek;
                    case periodTypes.immediately:
                        return Immediately;
                    default:
                        throw new Error(`Please add new component for type ${this.periodType}`);
                }
            },
            updatePeriodType(periodType) {
                this.$emit('update', {periodType});
            },
            updateData(data) {
                this.$emit('update', {
                    ...data,
                    periodType: this.periodType,
                });
            },
        },
    };
</script>
